import { gql } from '@apollo/client';

export const CREATE_COMPLIANCE_REPORT = gql`
  mutation CreateComplianceReport($input: CreateComplianceReportInput!) {
    createComplianceReport(input: $input) {
      id
      reportId
      reportType
      timeRange
      metricsSnapshot
      frameworksIncluded
      pdfExported
      exportCount
      createdAt
      reportingPeriodStart
      reportingPeriodEnd
      generatedByEmail
    }
  }
`;

export const MARK_REPORT_EXPORTED = gql`
  mutation MarkReportExported($reportId: String!) {
    markReportExported(reportId: $reportId) {
      id
      reportId
      pdfExported
      pdfExportedAt
      exportCount
    }
  }
`;

export const GET_COMPLIANCE_REPORTS = gql`
  query ComplianceReports($limit: Int) {
    complianceReports(limit: $limit) {
      id
      reportId
      reportType
      timeRange
      pdfExported
      exportCount
      createdAt
      generatedByEmail
    }
  }
`;

export const GET_COMPLIANCE_REPORT = gql`
  query ComplianceReport($reportId: String!) {
    complianceReport(reportId: $reportId) {
      id
      reportId
      reportType
      timeRange
      metricsSnapshot
      frameworksIncluded
      pdfExported
      pdfExportedAt
      exportCount
      createdAt
      reportingPeriodStart
      reportingPeriodEnd
      generatedByEmail
    }
  }
`;

// TypeScript interfaces
export interface ComplianceReport {
  id: string;
  reportId: string;
  reportType: string;
  timeRange: string;
  metricsSnapshot?: string;
  frameworksIncluded?: string[];
  pdfExported: boolean;
  pdfExportedAt?: string;
  exportCount: number;
  createdAt: string;
  reportingPeriodStart?: string;
  reportingPeriodEnd?: string;
  generatedByEmail?: string;
}

export interface CreateComplianceReportInput {
  timeRange: string;
  reportType?: string;
  safetyScore: number;
  activeSequences: number;
  totalExecutions: number;
  activeAlerts: number;
  categoriesMonitored: number;
  scheduledSequences: number;
  sequenceIds?: string[];
  categoryResults?: string;
}
